// utils/selectValueMapper.js

import { selectOptionsMap } from "pages/Marketplace/Campaign/data";

export const mapApiToForm = (apiData = {}) => {
  const formData = {};

  Object.keys(apiData).forEach((key) => {
    const options = selectOptionsMap[key];

    // If it's a Select field → map label to value
    if (options) {
      formData[key] =
        options.find((opt) => opt.label === apiData[key])?.value || "";
    } else {
      // Normal field (input, textarea, etc.)
      formData[key] = apiData[key];
    }
  });

  return formData;
};

export const mapFormToApi = (formData = {}) => {
  const apiPayload = {};

  Object.keys(formData).forEach((key) => {
    const options = selectOptionsMap[key];

    if (options) {
      apiPayload[key] =
        options?.find((opt) => opt.value === formData[key])?.label ||
        formData[key];
    } else {
      apiPayload[key] = formData[key];
    }
  });

  if (apiPayload.approval_status !== undefined) {
    apiPayload.status = apiPayload.approval_status;
    delete apiPayload.approval_status;
  }

  return apiPayload;
};
